export const props = () => [
];

export const init = () => ({
});

export const name = '中间变量';

export const component = 'mobile-general-form-hidden-variable';

import { events as baseEvents } from '../component-base/props';
export const events = [
    'change',
    ...baseEvents,
];
